import { RootState } from '../../root-store';
import { WalletCommonState } from './common';
import { MyWalletState } from './my-wallet';

export interface WalletState {
  common: WalletCommonState;
  myWallet: MyWalletState;
  sharedAccounts: MyWalletState;
}

export const selectWalletState = (state: RootState): WalletState =>
  state.features.walletStore;
